import React from "react";
import { useParams } from "react-router-dom";
import { ProfileCard } from "../../../../components/cards/ProfileCardApplicant";
import ProfileTabs from "../ProfileTabs";
import Training from "../../../applicant/Onboarding/TrainingNSpecialization/Training";
import Certification from "../../../applicant/Onboarding/TrainingNSpecialization/Certification";

export default function TrainingNSpecialization() {
  const { id } = useParams();
  return (
    <div className="container">
      <div className="row">
        <div className="col-md-12 mt-5">
          <div className="main_contents_div">
            <ProfileCard id={id} />
            <ProfileTabs id={id} />
            <Training id={id} />
            <Certification id={id} />
          </div>
        </div>
      </div>
    </div>
  );
}
